/**
 * Save a value to local storage.
 * @param key - The key to store the value under
 * @param value - The value to store
 */
export const saveToLocalStorage = (key: string, value: string): void => {
  localStorage.setItem(btoa(key), btoa(value));
};

/**
 *
 * @returns The value stored in local storage under the given key.
 */

export const getFromLocalStorage = (key: string): string => {
  return atob(localStorage.getItem(btoa(key)) || '');
};

/**
 * Get Access Token from local or session storage
 * @returns Access Token
 */
export const getAccessToken = (): string => {
  return getFromLocalStorage('access_token');
};

export interface TokensI {
  access_token: string;
  refresh_token: string;
}
/**
 * Save tokens to local storage
 * @param tokens - tokens to save to local storage
 */
export const saveTokensToLocalStorage = (tokens: TokensI): void => {
  saveToLocalStorage('access_token', tokens.access_token);
  saveToLocalStorage('refresh_token', tokens.refresh_token);
};

/**
 * Get tokens from local storage
 * @returns - {access_token, refresh_token} - from local storage
 */
export const getTokensFromLocalStorage = (): TokensI => {
  const access_token = getFromLocalStorage('access_token');
  const refresh_token = getFromLocalStorage('refresh_token');
  return { access_token, refresh_token };
};

/**
 * Remove tokens from local storage
 */
export const removeTokensFromLocalStorage = (): void => {
  localStorage.removeItem(btoa('access_token'));
  localStorage.removeItem(btoa('refresh_token'));
  localStorage.removeItem(btoa('email'));
};

/**
 * Clear all data from local storage
 */
export const clearLocalStorage = (): void => {
  localStorage.clear();
};

/**
 * Save Cookie to local storage
 * @param data - data to save to local storage
 * @param cookie - cookie name
 * @param path - cookie path
 */

export const saveDataToCookies = (data: string, cookie: string, path: string): void => {
  document.cookie = `${btoa(cookie)}=${btoa(
    data
  )}; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=${path}`;
};

/**
 * Get Cookie from local storage
 * @param cookie - cookie name
 * @returns - cookie value
 */

export const getDataFromCookies = (cookie: string): string => {
  return atob(document.cookie.match('(^|;)\\s*' + btoa(cookie) + '\\s*=\\s*([^;]+)')?.pop() || '');
};

export const removeReturnURLFromLocalStorage = (): void => {
  localStorage.removeItem(btoa('return_url'));
}

export const removeUserInfoFronLocalStorage = (): void => {
  localStorage.removeItem(btoa('name'));
  localStorage.removeItem(btoa('phone'));
  localStorage.removeItem(btoa('company'));
}